import keyBy from 'lodash/keyBy';
import { createSelector } from 'reselect';

import type { SupplySubAccount } from '@evenfinancial/finance-client';

import type { ApplicationState } from '../types';

/**
 * @deprecated
 * Use useGetSubAccountsQuery from api-client instead.
 */
export const selectDemandSubAccounts = (state: ApplicationState) =>
  state.subAccounts.demand;

/**
 * @deprecated
 * Use useGetSubAccountsQuery from api-client instead.
 */
export const selectSupplySubAccounts = (state: ApplicationState) =>
  state.subAccounts.supply;

/**
 * @deprecated
 * Use useGetSubAccountsQuery from api-client instead.
 */
export const selectAllSubAccounts = createSelector(
  [selectDemandSubAccounts, selectSupplySubAccounts],
  (demandSubAccounts, supplySubAccounts) =>
    demandSubAccounts.concat(supplySubAccounts)
);

/**
 * @deprecated
 * Use useGetSubAccountsQuery from api-client instead.
 */
export const selectAllSubAccountsKeyedByUuid = createSelector(
  [selectAllSubAccounts],
  (subAccounts) => keyBy(subAccounts, 'uuid')
);

export const selectHasSupplySubAccounts = (state: ApplicationState) =>
  Boolean(state.subAccounts.supply.length);

export const selectHasDemandSubAccounts = (state: ApplicationState) =>
  Boolean(state.subAccounts.demand.length);

export const selectHasBothSubAccountsTypes = createSelector(
  [selectHasSupplySubAccounts, selectHasDemandSubAccounts],
  (hasSupplySubAccounts, hasDemandSubAccounts) =>
    hasSupplySubAccounts && hasDemandSubAccounts
);

export const selectSupplySubAccountToDuplicate = ({
  subAccounts,
}: ApplicationState) =>
  subAccounts.supply.find(({ uuid }) => uuid === subAccounts.duplicateUuid) as
    | SupplySubAccount
    | undefined;
